'use client';

import {Calendar1, Clock} from 'lucide-react';
import type {Campaigns} from '@manaboo/db/types';
import {useAnimatedGradient} from '@manaboo/ui/hooks/use-animated-gradient';
import {plnToPoints, formatPoints} from '@manaboo/utils/points';
import {formatMinutes, formatDays, formatDifferentDays} from '@manaboo/utils/text';
import {CoinsBoos} from '@manaboo/ui/icons';

interface CardCampaignProps {
	campaign: Pick<Campaigns, 'condition_days' | 'condition_minutes' | 'rate'>;
}

export function CardCampaign({campaign}: CardCampaignProps) {
	const {animatedBorder} = useAnimatedGradient(true);

	return (
		<div
			className="relative rounded-md p-[3px]"
			style={animatedBorder}
		>
			<div className="bg-background rounded-md px-6 py-4">
				<h2 className="mb-5 text-xl">
					W tej grze dostępna jest misja! Podczas grania zarabiasz kasę. Co
					trzeba zrobić?
				</h2>

				<div className="grid gap-2 md:grid-cols-3 md:gap-5">
					<div className="bg-secondary flex items-center justify-center gap-4 rounded-md px-2 py-2 md:py-4">
						<CoinsBoos className="h-6 w-6 md:h-9 md:w-9" />
						<div>
							<div className="text-xl md:text-2xl">
								{formatPoints(plnToPoints(campaign.rate))}
							</div>
							<div className="text-muted-foreground text-sm">
								zarobek za ukończenie całej misji
							</div>
						</div>
					</div>

					<div className="bg-secondary flex items-center justify-center gap-4 rounded-md px-2 py-2 md:py-4">
						<Clock className="h-6 w-6 md:h-9 md:w-9" />
						<div>
							<div className="text-xl md:text-2xl">
								{formatMinutes(campaign.condition_minutes)}
							</div>
							<div className="text-muted-foreground text-sm">
								minimalny czas jednej gry
							</div>
						</div>
					</div>

					<div className="bg-secondary flex items-center justify-center gap-4 rounded-md px-2 py-2 md:py-4">
						<Calendar1 className="h-6 w-6 md:h-9 md:w-9" />
						<div>
							<div className="text-xl md:text-2xl">
								{formatDays(campaign.condition_days)}
							</div>
							<div className="text-muted-foreground text-sm">
								zagraj w tę grę w{' '}
								{formatDifferentDays(campaign.condition_days)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
